module.exports = function () {
    $(document).ready(function () {

        var helper = require('../../helper');
        var AjaxController = require('../../services/AjaxController');

        /** Make engine object */
        var engine = new Bloodhound({
            datumTokenizer: function (datum) {
                return Bloodhound.tokenizers.whitespace(datum.name);
            },
            queryTokenizer: Bloodhound.tokenizers.whitespace,
            remote: {
                url: helper.getOrigin() + "/api/guardians/all/search/%QUERY",
                wildcard: '%QUERY'
            },
            filter: function (response) {
                return $.map(response, function (object) {
                    return {
                        id: object.userId,
                        fullName: object.fullName,
                        email: object.email
                    };
                });
            }
        });

        /** Run TypeAhead */
        $('.js-guardian-add').typeahead(null, {
            minLength: 1,
            display: 'fullName',
            valueKey: 'id',
            name: 'suggestions',
            displayKey: 'fullName',
            limit: 15,
            templates: {
                empty: ['<div class="empty-message" style="padding: 10px;"><strong>', 'Unable to find guardians', '</strong></div>'].join('\n'),
                suggestion: function (data) {
                    return '<p style="font-size: 100%; cursor: pointer;"><strong>' + data.fullName + ' (' + data.email + ')' + '</strong></p>';
                }
            },
            source: engine
        });

        $('.js-guardian-add-to-viewing').bind('typeahead:select', function (ev, suggestions) {
            console.log(suggestions);

            var $this = $(this),
                index = $this.data('guardian');

            var newFieldGroup =
                '<div class="row">' +
                '<div class="col-sm-4 col-sm-offset-2">' +
                '   <div class="form-group">' +
                '       <label for="guardians['+index+'][guardianId]" class="control-label col-xs-12">'+suggestions.fullName+'</label>' +
                '   </div>' +
                '</div>' +
                '<div class="col-sm-1 pull-left">' +
                '   <button class="btn btn-remove" type="button" style="border:none;background:transparent;color:red;font-weight: bold;">Delete</button>' +
                '</div>' +
                '<input name="guardians['+index+'][guardianId]" type="hidden" value="'+suggestions.id+'"/></div>';

            var guardians = $('.guardians');

            $(newFieldGroup).appendTo(guardians);
            $('#guardian_title').val('');
            $this.data('guardian', ++index)
        });

        $(document).on('click', '.btn-remove', function(e)
        {
            $(this).parents('.row:first').remove();
            e.preventDefault();
            return false;
        });
    });
}();
